import { ViewportType } from '../../../enums/index.js';
export const VOLUME3D_PROJECTION_ID = 'volume3d';
